import React from "react";

function Divider({ onMoveUp, onMoveDown, onElementDelete }) {
  return (
    <div
      className="form-builder-element"
      style={{
        paddingTop: "5px",
        paddingBottom: "10px",
      }}
    >
      <button
        className="btn btn-danger btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onElementDelete}
      >
        <i className="fa fa-trash"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveUp}
      >
        <i className="fa fa-chevron-up"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveDown}
      >
        <i className="fa fa-chevron-down"></i>
      </button>
      <hr />
    </div>
  );
}

export default Divider;
